import { createStrictContext as e } from "../../temp-lib/util/context/createStrictContext.js";
import { jsx as i } from "react/jsx-runtime";
const [n, s] = e("AuthLib"), x = (t) => {
  const {
    children: o,
    config: r
  } = t;
  return /* @__PURE__ */ i(n, {
    value: {
      config: r
    },
    children: o
  });
};
export {
  x as AuthLibProvider,
  s as useAuthLibContext
};
//# sourceMappingURL=AuthLibContext.js.map
